import { ModalType } from "@outschool/gql-backend-generated";
import gql from "graphql-tag";
import { useQuery } from "react-apollo";

const MODAL_QUERY = gql`
  query ModalQuery {
    appState @client {
      openModal
    }
  }
`;

export default function useModal(modalName: ModalType): {
  isOpen: boolean;
  close: () => void;
} {
  const { data, client } = useQuery(MODAL_QUERY);

  const isOpen = data?.appState?.openModal === modalName;

  return {
    isOpen,
    close() {
      if (isOpen) {
        client.writeData({
          data: { appState: { __typename: "AppState", openModal: null } }
        });
      }
    }
  };
}
